import React from 'react';
import parse from 'html-react-parser';
import { useTheme } from '../../context/theme.context';

const InfoContainer = () => {
  const { legalText } = useTheme();

  return <div className="c-sii-info-container u-mt-24">{legalText && <>{parse(legalText)}</>}</div>;
};
InfoContainer.propTypes = {};
InfoContainer.defaultProps = {};

export default InfoContainer;
